export default "assets/images/icons/chevron-17b2cef7.svg";